export default __webpack_public_path__ + "static/media/logoNVIDIA_old.4a32b52c.png";